import { useEffect } from "react";

const SelectYear = ({ selectedYear, setSelectedYear, setSelectedSemester }) => {
    useEffect(() => {
        // Selecciona el último año por defecto al cargar
        setSelectedYear("2026");
        setSelectedSemester("1");
    }, [setSelectedYear, setSelectedSemester]);

    const handleChange = (e) => {
        const year = e.target.value;
        setSelectedYear(year);
        // Al cambiar el año, si es 2026 solo hay semestre 1
        setSelectedSemester(year === "2026" ? "1" : "1"); // luego se ajusta con SelectSemester
    };

    return (
        <div className="col-12 col-md-2">
            <h3 className="titles-form font-mpb">Año:</h3>
            <div className="caja">
                <select
                    name="years"
                    id="years"
                    className="form-select"
                    value={selectedYear}
                    onChange={handleChange}
                >
                    {Array.from({ length: 2027 - 2015 }, (_, i) => {
                        const year = (2015 + i).toString();
                        return (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        );
                    })}
                </select>
            </div>
        </div>
    );
};

export default SelectYear;
